import { Box } from '@mui/material';

import Tablet from './Tablet';
import Mobile from './Mobile';

const Menu = props => {
  const { lang, setLang } = props;

  const switchLang = () => {
    setLang(lang === 'sr' ? 'en' : 'sr');
  };

  const params = { lang, switchLang };

  return (
    <Box>
      <Tablet {...params}/>
      <Mobile {...params}/>
    </Box>
  );
};

export default Menu;
